// extracted by mini-css-extract-plugin
export default {"popup":"LevelUpPopup_popup__2Zsw4","popupContent":"LevelUpPopup_popupContent__cxzsV","popupFadeIn":"LevelUpPopup_popupFadeIn__lKQmF"};